"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceElement = void 0;
const MetaElement_1 = require("./MetaElement");
const Elements_1 = require("../helpers/Elements");
class ChoiceElement extends MetaElement_1.MetaElement {
    constructor(options) {
        super(options);
    }
    getChoiceBorder() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.choice-border');
    }
    getChoiceButton() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.choice-btn');
    }
    getChoiceText() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.choice-text');
    }
    getChoiceTextInside() {
        if (!this.shadowRoot) {
            return null;
        }
        return this.shadowRoot.querySelector('.choice-text-inside');
    }
    getChoiceIcon() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.choice-icon');
    }
    getChoiceIconInside() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.choice-cost-inside');
    }
    getChoiceCost() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.choice-cost');
    }
    getChoiceCostIcon() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.choice-cost-icon');
    }
    getMultiplayerContainer() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.choice-multiplayer-ui');
    }
    getWinningCheckmark() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.choice-winning-checkmark');
    }
    get analyticsBoxTopText() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.analytics-box-top span');
    }
    get analyticsBoxBottomText() {
        if (!this.shadowRoot) {
            return;
        }
        return this.shadowRoot.querySelector('.analytics-box-bottom span');
    }
    setIsEnabled(isEnabled = true) {
        this.classList.toggle('inactive', !isEnabled);
    }
    setIsSelected(isSelected) {
        this.classList.toggle('unselected', !isSelected);
    }
    set mainText(value) {
        const textElement = this.getChoiceTextInside();
        if (!textElement) {
            return;
        }
        textElement.innerHTML = value;
    }
    calculateBounds() {
        var _a, _b;
        if (!this.firstMeaningfulChild) {
            return MetaElement_1.DEFAULT_ELEMENT_BOUNDS;
        }
        const parentRect = (_b = (_a = this.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : { x: 0, y: 0 };
        const rect = (0, Elements_1.getBoundingBoxForElementAndChildren)(this.firstMeaningfulChild);
        rect.x -= parentRect.x;
        rect.y -= parentRect.y;
        const result = Object.assign(Object.assign({}, rect), { fontSize: 0, fontStyle: '', paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0, textAlign: 'center', textColor: 'black', fullElementBounds: Object.assign({}, rect) });
        const mainTextElement = this.getChoiceTextInside();
        if (mainTextElement) {
            const mainTextElementRect = (0, Elements_1.getBoundingBoxForElementAndChildren)(mainTextElement);
            mainTextElementRect.x -= parentRect.x;
            mainTextElementRect.y -= parentRect.y;
            const computedStyle = getComputedStyle(mainTextElement);
            result.fontFamily = computedStyle.fontFamily;
            result.fontSize = parseFloat(computedStyle.fontSize);
            result.fontStyle = computedStyle.fontWeight;
            result.textAlign = computedStyle.textAlign;
            result.textColor = computedStyle.color;
            if (computedStyle.lineHeight !== 'normal') {
                result.lineSpacing = parseFloat(computedStyle.lineHeight);
            }
            let { xMin: textXMin, xMax: textXMax, yMin: textYMin, yMax: textYMax, } = (0, Elements_1.getRectEdges)(mainTextElementRect);
            result.paddingLeft = parseFloat(computedStyle.paddingLeft);
            result.paddingTop = parseFloat(computedStyle.paddingTop);
            result.paddingBottom = parseFloat(computedStyle.paddingBottom);
            result.paddingRight = parseFloat(computedStyle.paddingRight);
            result.x = textXMin;
            result.y = textYMin;
            result.width = textXMax - textXMin;
            result.height = textYMax - textYMin;
            result.fullElementBounds = rect;
        }
        return result;
    }
}
exports.ChoiceElement = ChoiceElement;
